<form class="routed-component-layout" [formGroup]="form" novalidate autocomplete="off">

  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.TITLE' | translate }}</h2>
    </div>

    <div class="field-group-layout">

      <!-- Email (readonly, display only) -->
      <soldo-field-layout [control]="form.controls.email" fieldName="email" cypressSelector="Signup_TextInput_Email"
        label="REGISTRATION.SIGNUP_STEP.SIGNUP.EMAIL_LABEL">
        <input input type="email" name="email" formControlName="email" readonly />
      </soldo-field-layout>

      <!-- First Name -->
      <soldo-field-layout [control]="form.controls.firstName" fieldName="firstName"
        cypressSelector="Signup_TextInput_LeadFirstName" label="REGISTRATION.SIGNUP_STEP.SIGNUP.FIRST_NAME_LABEL">
        <input input type="text" name="firstName" formControlName="firstName" />
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.FIRST_NAME_REQUIRED' |
            translate }}</soldo-field-error>
          <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate : { value:
            form.controls.firstName.errors?.maxlength?.requiredLength } }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      <!-- Last Name -->
      <soldo-field-layout [control]="form.controls.lastName" fieldName="lastName"
        cypressSelector="Signup_TextInput_LeadLastName" label="REGISTRATION.SIGNUP_STEP.SIGNUP.LAST_NAME_LABEL">
        <input input type="text" name="lastName" formControlName="lastName" />
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.LAST_NAME_REQUIRED' | translate
            }}</soldo-field-error>
          <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate : { value:
            form.controls.lastName.errors?.maxlength?.requiredLength } }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      <!-- Country of Incorporation -->
      <soldo-field-layout [control]="form.controls.country" fieldName="country"
        cypressSelector="Signup_NgSelect_CountryOfIncorporation" label="REGISTRATION.SIGNUP_STEP.SIGNUP.COUNTRY_LABEL">
        <ng-select input formControlName="country" [items]="countryOptions" bindLabel="name" bindValue="iso3"
          groupBy="group" [selectableGroup]="false" [clearable]="false"
          notFoundText="{{ 'NO_ITEMS_FOUND' | translate }}"
          placeholder="{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.COUNTRY_PLACEHOLDER' | translate }}" name="country">
          <ng-template ng-optgroup-tmp let-item="item">
            <span class="country-group-label">{{ item.group | translate }}</span>
          </ng-template>
        </ng-select>
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      <!-- Company Name -->
      <soldo-field-layout [control]="form.controls.companyName" fieldName="companyName"
        cypressSelector="Signup_TextInput_CompanyName" label="REGISTRATION.SIGNUP_STEP.SIGNUP.COMPANY_NAME_LABEL">
        <input input type="text" name="companyName" formControlName="companyName" />
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.COMPANY_NAME_REQUIRED' |
            translate }}</soldo-field-error>
          <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate : { value:
            form.controls.companyName.errors?.maxlength?.requiredLength } }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

      <!-- Company Type -->
      @if (!hasCompanyTypes && !companyTypesLoading && form.controls.country.value) {
      <soldo-field-layout [control]="form.controls.companyTypeOther" fieldName="companyTypeOther"
        cypressSelector="Signup_TextInput_CompanyTypeOther" label="REGISTRATION.SIGNUP_STEP.SIGNUP.COMPANY_TYPE_LABEL">
        <input input type="text" name="companyTypeOther" formControlName="companyTypeOther" />
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
          <soldo-field-error errorName="maxlength">{{ 'MAX_LENGHT' | translate : { value:
            form.controls.companyTypeOther.errors?.maxlength?.requiredLength } }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>
      } @else {
      <soldo-field-layout [control]="form.controls.companyType" fieldName="companyType"
        cypressSelector="Signup_NgSelect_CompanyType" label="REGISTRATION.SIGNUP_STEP.SIGNUP.COMPANY_TYPE_LABEL">
        <ng-select input formControlName="companyType" [items]="companyTypesFlat" bindLabel="label" bindValue="value"
          groupBy="category" [selectableGroup]="false" [clearable]="false" [loading]="companyTypesLoading"
          notFoundText="{{ 'NO_ITEMS_FOUND' | translate }}" name="companyType">
          <ng-template ng-optgroup-tmp let-item="item">
            <span class="country-group-label">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.COMPANY_TYPE_CATEGORY.' + item.category + '_LABEL' |
              translate }}</span>
          </ng-template>
        </ng-select>
        <ng-container errorMessage>
          <soldo-field-error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>
      }

      <!-- Number of Employees -->
      <div>
        <soldo-field-layout [control]="form.controls.companySize" fieldName="companySize"
          cypressSelector="Signup_NgSelect_EntitySize"
          label="REGISTRATION.SIGNUP_STEP.SIGNUP.NUM_EMPLOYEES_LABEL">
          <ng-select input formControlName="companySize" [clearable]="false"
            notFoundText="{{ 'NO_ITEMS_FOUND' | translate }}" name="companySize">
            <ng-option *ngFor="let option of companySizeOptions" [value]="option.value">
              {{ option.label | translate }}
            </ng-option>
          </ng-select>
          <ng-container errorMessage>
            <soldo-field-error errorName="required">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.RANGE_REQUIRED' |
              translate }}</soldo-field-error>
          </ng-container>
        </soldo-field-layout>

        <div class="conditional-subfield-container" *ngIf="fewerThan50Mode">
          <soldo-field-layout [control]="form.controls.companySizeFewerThan50" fieldName="companySizeFewerThan50"
            cypressSelector="Signup_TextInput_EntitySize">
            <input input type="text" inputmode="tel" name="companySizeFewerThan50" placeholder="{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.FEWER_THAN_50_PLACEHOLDER' | translate}}"
              formControlName="companySizeFewerThan50" (focus)="selectOnFocus($event)">
            <ng-container errorMessage>
              <soldo-field-error errorName="required">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.NUMBER_REQUIRED' |
                translate }}</soldo-field-error>
              <soldo-field-error errorName="min">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.ENTER_VALID_NUMBER' |
                translate }}</soldo-field-error>
              <soldo-field-error errorName="max">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.ENTER_VALID_NUMBER' |
                translate }}</soldo-field-error>
              <soldo-field-error errorName="pattern">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.ENTER_VALID_NUMBER' |
                translate }}</soldo-field-error>
            </ng-container>
          </soldo-field-layout>
        </div>
      </div>

      <!-- Website (optional) -->
      <soldo-field-layout [control]="form.controls.website" fieldName="website"
        cypressSelector="Signup_TextInput_Website" label="REGISTRATION.SIGNUP_STEP.SIGNUP.WEBSITE_LABEL">
        <input input type="url" name="website" formControlName="website"
          placeholder="{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.WEBSITE_PLACEHOLDER' | translate }}" />
        <ng-container errorMessage>
          <soldo-field-error errorName="pattern">{{ 'REGISTRATION.SIGNUP_STEP.SIGNUP.WEBSITE_INVALID' | translate
            }}</soldo-field-error>
        </ng-container>
      </soldo-field-layout>

    </div>
  </div>

  <!-- Navigation -->
  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()" [disabled]="loading" data-cy="Signup_Button_PreviousStepButton">
        {{ 'REGISTRATION.SIGNUP_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>
      <button type="submit" class="primary" (click)="nextStep()" [disabled]="loading" [ngClass]="{ 'loading': loading }"
        data-cy="Signup_Button_NextStepButton">
        {{ 'REGISTRATION.SIGNUP_STEP.NEXT_SUB_STEP_BUTTON' | translate }}
      </button>
    </div>
  </div>

</form>
